import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "../../i18n/I18nProvider";
import { getSolutions } from "../../i18n/content";

export default function Solutions() {
  const { t, locale } = useI18n();
  const solutions = getSolutions(locale);
  return (
    <section
      data-testid="solutions-section"
      className="py-24 sm:py-32 bg-zinc-50"
    >
      <div className="container-oj">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14">
          <div className="md:col-span-4">
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-zinc-500">{t("sections.solutions_overline")}</div>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-display text-balance text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95] text-oj-ink">
              {t("sections.solutions_title")}<br />{t("sections.solutions_title_2")}
            </h2>
            <p className="mt-5 max-w-2xl text-lg text-zinc-600 leading-relaxed">
              {t("sections.solutions_sub")}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-6 gap-5">
          {solutions.filter((s) => !s.hidden).map((s, i) => {
            const layouts = [
              "md:col-span-4",  // POS - large
              "md:col-span-2",  // Kiosk
              "md:col-span-2",  // Waiter
              "md:col-span-2",  // QR
              "md:col-span-2",  // Online shop
              "md:col-span-3",  // Payment
              "md:col-span-3",  // Loyalty
            ];
            const span = layouts[i] || "md:col-span-3";
            return (
              <Link
                to={`/solutions/${s.slug}`}
                key={s.slug}
                data-testid={`solution-card-${s.slug}`}
                className={`group relative ${span} rounded-2xl p-8 sm:p-10 overflow-hidden text-white transition-transform hover:-translate-y-1 duration-300`}
                style={{ backgroundColor: s.color }}
              >
                <div className="absolute inset-0 noise opacity-30 mix-blend-overlay pointer-events-none" />
                <div className="relative flex items-start justify-between gap-4">
                  <div className="font-mono text-[11px] uppercase tracking-[0.25em] opacity-80">/{String(i + 1).padStart(2, "0")} · {s.short}</div>
                  <ArrowUpRight className="size-5 opacity-80 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </div>
                <div className="relative mt-10">
                  <h3 className="font-display text-3xl sm:text-4xl font-black tracking-tighter leading-none">{s.name}</h3>
                  <p className="mt-3 text-white/90 text-base sm:text-lg max-w-md leading-snug">{s.tagline}</p>
                </div>
                <div className="relative mt-8 flex flex-wrap gap-2">
                  {s.bullets.slice(0, 3).map((b) => (
                    <span key={b} className="text-[11px] font-medium uppercase tracking-wider bg-white/15 backdrop-blur rounded-full px-2.5 py-1">
                      {b}
                    </span>
                  ))}
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
